import swipevideo from './swipevideo.esm.js';
import sva from './sva.js';
import axios from 'axios';

// ga
var ga = document.createElement( 'script' );
ga.type = 'text/javascript';
ga.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.GOOGLE_ANALYTICS}`;
var s = document.getElementsByTagName('script')[0];
s.parentNode.insertBefore(ga, s);

// player
var contentId = 'cdntest1';
var matchs = window.location.search.match(/÷?id=([^&]+)/);
if (matchs) {
  contentId = matchs[1];
}

window.addEventListener('DOMContentLoaded', function() {
  // ga
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', process.env.GOOGLE_ANALYTICS);

  // sva
  let prevTime;
  const logger = state => {
    // TODO 今回は使用しない
    // sva({
    //   cid: contentId,
    //   fmt: prevTime,
    //   tot: state.currentTime,
    //   idx: state.srcIndex,
    //   fps: state.fps,
    //   zsc: state.zoomScale,
    //   zox: state.zoomOrigin.x,
    //   zoy: state.zoomOrigin.y,
    // });
    prevTime = state.currentTime;
  };

  // player
  const deliver_urls = process.env.DELIVER_URLS.split(',');
  var baseUrl = deliver_urls[Math.floor( Math.random() * deliver_urls.length)] + contentId + '/';

  axios.get(baseUrl + 'info.json').then( response =>{
    console.log(response.data.srcset[0]);
    const audioUrl = response.data.srcset[0] + '/audio.mp3';

    var container = document.getElementById('container');
    swipevideo.attach(container, {
      src: baseUrl + 'info.json',
      audio: baseUrl + audioUrl,
      pattern: baseUrl + '${src}/%d.jpg',
      allowfullscreen: true,
      autoRotate: false,
      linkTitle: '#FNS歌謡祭',
      linkUrl: 'https://www.fujitv.co.jp/FNS/index.html?sv',
    }).then(function(operater) {
      let timer;
  
      operater
      .requestFullscreen()
      .on('play', function() {
        console.log('play()');
  
        setTimeout(function(){
          document.getElementsByClassName('Controls__switch')[1].style.display = 'none';
        }, 100);
  
        gtag('event', 'play', {
          'event_category': contentId,
          'event_label': 0
        });
  
        prevTime = operater.state.currentTime;
        timer = setInterval(function() {
          // TODO player側でzoom等取れるようになるまでの暫定対応
          operater.state.zoomScale = operater.vue.$root.$children[0].$children[0].zoomScale;
          operater.state.zoomOrigin = operater.vue.$root.$children[0].$children[0].zoomOrigin;
          logger(operater.state);
        }, 1000);
      })
      .on('pause', function() {
        console.log('pause()');
  
        setTimeout(function(){
          if (document.getElementsByClassName('Ending__btn').length === 0) {
            return;
          }
          document.getElementsByClassName('Ending__btn')[1].style.display = 'none';
        }, 100);
  
        clearInterval(timer);
      });
      // .play();
    });   
  });
}, false);